// Behaviour for the bespoke Sacksy header: mobile drawer and dropdown a11y.
// Sticky / transparent state (data-sticky-state) is owned by Horizon's
// header.js; critical.js owns --header-height and the hero offset.

function initDrawer(header) {
  const drawer = header.querySelector('[data-drawer]');
  const toggle = header.querySelector('[data-drawer-toggle]');
  if (!drawer || !toggle) return;

  let previousOverflow = '';

  const closeButton = drawer.querySelector('.sacksy-drawer__close');

  const open = () => {
    drawer.hidden = false;
    previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(() => drawer.classList.add('is-open'));
    toggle.setAttribute('aria-expanded', 'true');
    closeButton?.focus();
  };

  const close = () => {
    if (drawer.hidden) return;
    drawer.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = previousOverflow;
    const onEnd = (event) => {
      if (event.target !== drawer.querySelector('.sacksy-drawer__panel')) return;
      drawer.hidden = true;
      drawer.removeEventListener('transitionend', onEnd);
    };
    drawer.addEventListener('transitionend', onEnd);
    toggle.focus();
  };

  toggle.addEventListener('click', () => {
    drawer.hidden ? open() : close();
  });

  drawer.querySelectorAll('[data-drawer-close]').forEach((el) => {
    el.addEventListener('click', close);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || drawer.hidden) return;
    // Collapse the deepest open accordion first; only then close the drawer.
    const openDetails = [...drawer.querySelectorAll('details[open]')].pop();
    if (openDetails) {
      openDetails.open = false;
      openDetails.querySelector('summary')?.focus();
      return;
    }
    close();
  });
}

function initDropdowns(header) {
  const items = header.querySelectorAll('.sacksy-nav__item--has-children');

  items.forEach((item) => {
    const link = item.querySelector('.sacksy-nav__link');
    if (!link) return;

    const setExpanded = (value) => link.setAttribute('aria-expanded', value ? 'true' : 'false');

    item.addEventListener('pointerenter', () => setExpanded(true));
    item.addEventListener('pointerleave', () => setExpanded(false));
    item.addEventListener('focusin', () => setExpanded(true));
    item.addEventListener('focusout', (event) => {
      if (!item.contains(event.relatedTarget)) setExpanded(false);
    });
    item.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      setExpanded(false);
      link.focus();
    });
  });
}

function init() {
  const header = document.getElementById('header-component');
  if (!header || header.dataset.sacksyHeaderReady === 'true') return;
  header.dataset.sacksyHeaderReady = 'true';

  initDrawer(header);
  initDropdowns(header);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

// Shopify theme editor re-renders the section; re-run to rebind.
document.addEventListener('shopify:section:load', (event) => {
  if (event.target.querySelector('#header-component')) {
    const header = document.getElementById('header-component');
    if (header) delete header.dataset.sacksyHeaderReady;
    init();
  }
});
